class MediaCommand {
    constructor(app, streamManager, nextCommand) {
        this.app = app;
        this.streamManager = streamManager;
        this.nextCommand = nextCommand;
    }

    runMediaCommand(configurableStream) {
        const config = configurableStream.config();
        this.streamManager.setMirror(configurableStream.stream());
        this.nextCommand.run(config);
    }
}

export default MediaCommand;
